// The foundation primitives' own words (F4a): the ones the shared label module does not carry. Each quotes the line
// of the vendored design-system excerpts it comes from; labels.test.mjs checks every quote and status.

import { defineLabels } from "../labels";

const TAG_WORDS = "*Limited* · *Internal* · *No vote* · *Oversight* · *Coordinator* · *Revised*";

/** Tag words (DS #32) that carry a tone of their own. */
export const TAG_LABELS = /* @__PURE__ */ defineLabels({
  limited: { text: "Limited" },
  internal: { text: "Internal" },
  revised: { text: "Revised" },
});

/** Words of the feedback primitives: the error strip, empty states, the inline confirmation, a filter chip's remove. */
export const CORE_LABELS = /* @__PURE__ */ defineLabels({
  syncFailure: { text: "Sync failure" },
  noAssessmentTask: { text: "No assessment task when Not Required" 


},
  nothingNeedsAction: { text: "Nothing needs action" },
  /** The empty History tab's own line: his BRD §4.1 sentence for what History keeps, until Q-D3 gives it his wording. */
  retainHistory: { text: "Close automatically when resolved; retain history." 


},
  recordedAuditEvent: { text: "Recorded · audit event" },
  certificationRequiredFirst: { text: "Certification required first" 

},
  clear: { text: "Clear" },
});

const CARD_TITLES = "card titles from his nouns (*Coverage validator*, *Offer readiness*, *Attendance roll*)";
const SCOPE_WORDS = "`.cs` carries the scope word on Home widgets (*Enterprise*, *Assigned*, *Own reqs*)";
const SECTION_WORDS = "*Breach — dashboard risk* · *Near-breach* · *Reminder* · *Due* · *Drivers* · *Missing prerequisites*";
const TOGGLE_WORDS = "*Executive participation* · *Add to talent community* · *Show previous versions*";
const MENU_WORDS = "reason codes · *Edit · View history* · export formats (Q-E28)";
const BAR_WORDS = "*Load* · *Workload* · *Expertise* · *Decline reasons* · *Candidates by stage*";
const LANE_WORDS = "*Interviewer* · the *virtual / onsite / hybrid* `seg` (no label) · *Executive participation · ROOTS · Skill · Load*";
const REFCHECK_FIELDS = "*Owner* (`pick`) · *Provider* (`select`) · *Requested* (date) · *Completed* (date) · *Outcome* (`select`) · *Notes* (`inp.ta`, `tag.internal`)";

/**
 * Words of the surfaces, forms, data and menu primitives (F4b) and their gallery: card titles and scope words (DS #7,
 * #8), section titles (#11), toggles (#21), menu verbs (#73), bar labels (#42), and field and column names his rows
 * carry (#57 lane fields, #123 reference-check fields).
 */
export const SURFACE_LABELS = /* @__PURE__ */ defineLabels({
  coverageValidator: { text: "Coverage validator" },
  offerReadiness: { text: "Offer readiness" },
  attendanceRoll: { text: "Attendance roll" },
  enterprise: { text: "Enterprise" },
  assigned: { text: "Assigned" },
  ownReqs: { text: "Own reqs" },
  drivers: { text: "Drivers" },
  missingPrerequisites: { text: "Missing prerequisites" },
  executiveParticipation: { text: "Executive participation" },
  addToTalentCommunity: { text: "Add to talent community" },
  showPreviousVersions: { text: "Show previous versions" },
  edit: { text: "Edit" },
  viewHistory: { text: "View history" },
  load: { text: "Load" },
  workload: { text: "Workload" },
  expertise: { text: "Expertise" },
  declineReasons: { text: "Decline reasons" },
  candidatesByStage: { text: "Candidates by stage" },
  skill: { text: "Skill" },
  owner: { text: "Owner" },
  provider: { text: "Provider" },
  outcome: { text: "Outcome" },
  notes: { text: "Notes" },
});
